import { useEffect, useRef, useState } from 'react';
import { api, getErrorMessage, setReauthenticationHandler } from './api/client';

export default function AdminReauthentication() {
  const dialog = useRef(null), resolve = useRef(null), opener = useRef(null);
  const [busy, setBusy] = useState(false), [error, setError] = useState('');
  useEffect(() => {
    setReauthenticationHandler(() => new Promise(done => {
      resolve.current = done; opener.current = document.activeElement;
      setError(''); dialog.current?.querySelector('form')?.reset(); dialog.current?.showModal();
    }));
    return () => { setReauthenticationHandler(null); resolve.current?.(false); };
  }, []);
  const finish = value => {
    resolve.current?.(value); resolve.current = null;
    dialog.current?.querySelector('form')?.reset(); dialog.current?.close(); opener.current?.focus();
  };
  async function submit(event) {
    event.preventDefault(); if (busy) return;
    const code = new FormData(event.currentTarget).get('code').trim();
    setBusy(true); setError('');
    try { await api.post('/auth/step-up', { code }); finish(true); }
    catch (err) { setError(getErrorMessage(err)); }
    finally { setBusy(false); }
  }
  return <dialog ref={dialog} className="admin-reauth-dialog" aria-labelledby="reauth-title" onCancel={event => { event.preventDefault(); if (!busy) finish(false); }}>
    <h2 id="reauth-title">Confirm your identity</h2>
    <p>Enter a new authenticator code or unused recovery code to continue. Your changes will be submitted after verification.</p>
    <form onSubmit={submit}>
      <label>Authenticator or recovery code<input name="code" autoComplete="one-time-code" autoFocus required minLength={6} maxLength={24} pattern="[0-9]{6}|[a-fA-F0-9]{24}" disabled={busy} /></label>
      {error && <p className="alert" role="alert">{error}</p>}
      <div className="admin-reauth-actions"><button className="secondary-button" type="button" disabled={busy} onClick={() => finish(false)}>Cancel</button><button className="primary-button" disabled={busy}>{busy ? 'Verifying…' : 'Confirm and continue'}</button></div>
    </form>
  </dialog>;
}
